<template>
  <div class="header">
    <logo/>
    <div class="header__flex">
      <navigation/>
      <div class="flags">
        <button v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">
          <flag :iso="entry.flag" v-bind:squared="false"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Logo";
import Navigation from "@/components/Navigation";
import { EventBus } from "../plugins/event-bus.js";
import i18n from "@/plugins/i18n";

export default {
  components: {
    Logo,
    Navigation
  },
  data() {
    return {
      languages: [
        { flag: "pl", language: "pl", title: "PL" },
        { flag: "gb", language: "en", title: "EN" }
      ]
    };
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
      EventBus.$emit("language-change", locale);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: sticky;
  top: 0;
  width: 100%;
  height: 8.5rem;
  background-color: $white;
  z-index: 99;
  padding: 0 4rem;
  box-sizing: border-box;
  @include flex(center, space-between, row);
  &__flex {
    display: flex;
    flex-wrap: nowrap;
  }
}
.flags {
  margin-left: 30px;
  transform: translateY(-3px);
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: white;
}

button {
  border: 0;
  outline: none;
  background-color: white;
  &:hover {
    cursor: pointer;
    padding-bottom: 1px;
    transform: translateY(-1px);
  }
}
</style>